/* Kloopp — políticas: arma el índice "En esta página" a partir de los títulos (h2) del contenido.
   Sin JS el índice simplemente no aparece y la página se lee igual. */
(function () {
  var body = document.querySelector('[data-policy-body]');
  var toc = document.querySelector('[data-policy-toc]');
  if (!body || !toc) return;

  var headings = body.querySelectorAll('h2');
  if (headings.length < 2) return;

  function slugify(text) {
    return (
      text
        .toLowerCase()
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '') || 'seccion'
    );
  }

  var links = toc.querySelector('[data-policy-toc-links]');
  var used = {};

  Array.prototype.forEach.call(headings, function (heading) {
    var id = heading.id;
    if (!id) {
      var base = slugify(heading.textContent);
      id = base;
      var n = 2;
      while (used[id] || document.getElementById(id)) {
        id = base + '-' + n;
        n += 1;
      }
      heading.id = id;
    }
    used[id] = true;

    var link = document.createElement('a');
    link.href = '#' + id;
    link.textContent = heading.textContent;
    links.appendChild(link);
  });

  /* El índice va después de la introducción, antes del primer título */
  headings[0].parentNode.insertBefore(toc, headings[0]);
  toc.hidden = false;
})();
